<template>
  <div class="protocol">
    <p class="18" align="right" style="text-align: right">
      <span>【更新时间：</span>2021年9月20日】
    </p>
    <p class="p">尊敬的用户：</p>
    <p class="p" style="text-indent: 24.1pt">
      <b>恭喜您成为壹心理的创作者</b><b>，</b><b>并使用壹心理鲸币产品。</b
      ><b></b>
    </p>
    <p class="p" style="text-indent: 24.1pt">
      <b>壹心理提醒您，</b><b>凡使用壹心理鲸币产品应当</b
      ><b
        >仔细阅读以下全部内容，特别以加粗或其他合理方式提示您注意，并请您重点阅读的条款。如果您不同意本协议的任一或全部条款内容，请不要以确认的形式（包括但不限于：点击</b
      ><b>确认</b><b>、进入</b><b>使用</b><b>程序等）进行下一步操作或使用</b
      ><b>壹心理鲸币产品</b><b>服务。</b><b></b>
    </p>
    <p class="p" style="text-indent: 24.1pt">
      <b>本规则属于《壹心理用户注册协议》（用户协议）的重要组成部分。</b><b></b>
    </p>
    <p class="p" style="text-indent: 24.1pt">
      <b>&nbsp;</b>
    </p>
    <p class="MsoNormal" style="text-indent: 28.2pt">定义</p>
    <p class="MsoNormal" style="text-indent: 28.2pt">
      <b>鲸币账户：</b
      >指经有效程序注册后，在壹心理平台使用鲸币功能的个人账户，可以查看：鲸币账户余额、鲸币账户收益等。<b
      ></b>
    </p>
    <p class="MsoNormal" style="text-indent: 24.1pt">
      <b>鲸币：</b
      >指鲸币账户中，通过充值、任务收益等途径可获取壹心理平台的虚拟积分的名称，该虚拟积分不属于现实货币或金融产品，不得以现实货币等形式进行任何交易行为。
    </p>
    <p class="MsoNormal" style="text-indent: 24.1pt">
      <b>账户</b
      ><b>充值功能：</b
      >用户可以通过充值形式获得鲸币，鲸币依照本规则可以用于壹心理平台消费（包括平台直播打赏、购买部分产品等），具体以平台标示为准，充值的鲸币不得提现（另有规定除外）。
    </p>
    <p class="MsoNormal" style="text-indent: 24.1pt">
      <b>账户收益功</b><b>能：</b>用户通过打赏等功能获得的鲸币可以提现。
    </p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 0pt">&nbsp;</p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 20pt">
      一、鲸币使用说明
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      1．在同意本使用规则的前提下，用户有权选择开通、使用鲸币账户，包括使用充值功能、打赏功能等。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      2．通过认证的<span>用户（详见壹心理</span>app-我的-<span>创作者中心</span>-引力值认证徽章-查看认证规则并按规则获得认证：通过绑定认证信息和支付宝账户），可以开通鲸币收益功能，可以使用充值功能、打赏功能。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      3．为了保障用户的合法权益，鲸币账户余额未清零的，用户无法自行注销鲸币账户。鲸币账户清零后，可以注销鲸币账户。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      4．注销鲸币账户的，对壹心理平台帐户无影响；注销壹心理平台帐户的，即鲸币账户同步注销，因此导致鲸币账户清零或任何损失的，由用户自行负责。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      5．鲸币使用（消费）范围：鲸币可用于壹心理平台的直播打赏、购买部分产品、兑换部分产品等，具体使用形式与消费、兑换、使用标准，以使用详情页标示为准。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      6．为了更好地为用户提供鲸币功能的使用，用户同意壹心理有权在鲸币功能范围内使用用户提供的个人信息、登记账户信息，壹心理使用该信息时应当严格遵守法律规定，不得超出合理范围，不得将上述信息提供给任何第三方。
    </p>
    <p class="MsoNormal" style="margin-left: 8.6pt; text-indent: 0pt">&nbsp;</p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 20pt">
      二、充值功能
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      1．<span>充值比例：人民币</span>1元 =
      10个鲸币（充值标准以充值页面标示为准）。
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      2．<b>通过充值</b><b>功能，</b><b>购买获得</b><b>的</b><b>鲸币，</b
      ><b>仅按照本鲸币使用规则，有权将鲸币用于平台消费</b><b>，</b><b>无法</b
      ><b>提现。</b><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      3．退费：用户有权根据鲸币账户页面流程操作退费申请，壹心理在收到退费申请的七个工作日内按原路退回充值费用。
    </p>
    <p class="MsoNormal" style="margin-left: 8.6pt; text-indent: 0pt">&nbsp;</p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 20pt">
      三、收益功能
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      1．账户收益功能来源：
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （1）壹心理平台发放的补贴、奖励
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （2）按《用户协议》获得的收费服务收入
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （3）其他用户的打赏
    </p>
    <p class="MsoNormal" style="margin-left: 44pt; text-indent: 0pt">
      <b>（</b><b>通过充值功能消费获得的鲸币不得提现</b><b>）</b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      2．用户享有鲸币的使用权和提现权。
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      3．<b>由于</b><b>用户</b><b>过失操作导致的</b
      ><b>功能异常</b
      >（包括但不限于无法提现、提现失败、鲸币丢失、结算延迟、错误打赏、提现至错误账户等）<b
        >导致</b
      ><b>的</b><b>损失由用户自行承担</b
      ><b>；</b>出现上述情况，用户应当及时联系壹心理处理，减轻损失，但<b
        >壹心理不对该损失承担责任</b
      ><b>。</b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      4．<b>由于系统原因导致的</b
      ><b>功能异常</b
      >（包括但不限于无法提现、提现失败、鲸币丢失、结算延迟、错误打赏、提现至错误账户等）<b
        >导致</b
      ><b>的</b><b>损失由</b><b>壹心理承担</b><b>；</b
      ><b>出现上述情况，用户应当及时联系壹心理处理，壹心理在</b
      ><b>七个工作日内核实情况并回复处理结果</b><b>。</b><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      5．您在提现操作过程中遇到任何困难，可以通过壹心理平台反馈功能将情况反馈给壹心理，由壹心理协助处理。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      6．壹心理为打赏功能提供技术服务支持，为维持打赏功能的正常运营，用户提现过程中将收取成本服务费（以提现页面提示为准）。
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      7．<b>根据税务相关法律规定，用户提现的税费由用户自行承担，</b>其中个人所得税由壹心理代扣代缴，<b
        >由</b
      ><b>壹心理代扣代缴</b
      ><b>用户的个人所得税后，将剩余费用提现支付至用户登记的账户</b>。
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      8．鲸币提现规则：
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （1）10个鲸币&nbsp;= 1元（人民币）<b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （2）<span>每</span>100个<span>鲸币可以提现</span>1次，可以累积提现<b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 74.1pt; text-indent: -30.1pt">
      （3）<b
        ><span>到账金额不等于提现鲸币金额，到账金额</span> = 提现金额 -
        扣除成本服务费、个人所得税后的实际费用</b
      ><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 74pt; text-indent: -30pt">
      （4）一个自然月内可以多次提现，<b>提现款项</b><b>统一在提现操作通过后</b
      ><b><span>次月</span>15日前</b
      ><b
        >支付至用户登记的账户（遇节假日、停工罢工等不可抗力情况的，顺延至最近的工作日处理）</b
      >
    </p>
    <p class="MsoNormal" style="margin-left: 16.5pt; text-indent: 0pt">
      <b><u>&nbsp;</u></b>
    </p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 20pt">
      四、功能调整
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      1．<b>壹心理</b><b>有权</b><b>根据渠道扣费、运营成本等情况</b><b>，</b
      ><b>对</b><b>充值功能、</b><b>打赏功能</b><b>等</b><b>进行</b><b>规则</b
      ><b>调整等。</b
      ><b
        >自调整之日起按调整后的规则执行，调整前已充值、已提现的费用，按原有规则执行</b
      ><b>。</b><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      2．规则调整后：非使用本规则另有规定，<b>调整后的充值、提现操作</b><b>对</b
      ><b>过往</b><b>交易不具有溯及力。</b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.1pt; text-indent: -18pt">
      3．用户对调整后的规则<b>有疑问或</b><b>持有</b><b>异议的，请</b><b>暂停</b
      ><b>使用</b><b>鲸币</b
      ><b>功能</b>，及时通过壹心理平台反馈功能将情况反馈给壹心理。<b>凡</b
      ><b>继续使用</b><b>鲸币的</b><b>行为</b><b>，</b><b>视为同意按</b
      ><b>调整后的规则</b><b>执行</b><b>。</b>
    </p>
    <p class="MsoNormal" style="margin-left: 20pt; text-indent: 0pt">&nbsp;</p>
    <p class="MsoNormal" style="margin-left: 0pt; text-indent: 20pt">
      五、规则终止
    </p>
    <p class="MsoNormal" style="margin-left: 44pt; text-indent: 24pt">
      出现以下情况，《壹心理鲸币使用规则》终止，用户无法使用鲸币账户及相关服务，<b
        >仅鲸币账户的注销不影响平台账户的继续使用。</b
      >
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      1．<b>用户</b
      ><b
        >注销壹心理平台帐户的，即鲸币账户同步注销，因此导致鲸币账户清零或任何损失的，由用户自行负责。</b
      ><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      2．<b>用户</b><b>不接受本规则变更或个人原因，</b><b>注销鲸币账户的。</b
      ><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      3．<b>用户</b><b>违反</b><b>《</b><b>用户协议</b><b>》、</b
      ><b>服务协议或相关规则，被注销平台帐户的。</b><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      4．<b>用户违反</b><b>鲸币使用规则，</b><b>被注销鲸币帐户的。</b><b></b>
    </p>
    <p class="MsoNormal" style="margin-left: 43.15pt; text-indent: -18.05pt">
      5．<b>其它</b
      ><b>扰乱鲸币使用规则或妨碍其他用户使用鲸币的行为，被注销鲸币帐户的</b
      ><b>。</b><b></b>
    </p>
    <p class="MsoNormal">&nbsp;</p>
  </div>
</template>

<script>
export default {
  name: 'Protocol',
}
</script>
<style lang="scss" scoped>
.protocol {
}
</style>
